<div class="alerts" *ngIf="editModeSet || (airport.alerts && airport.alerts.length)">
  <div [ngClass]="{'alert': true, 'alert__container':true, 'alert--notice': lowPriority(alert.priority) }" *ngFor="let alert of airport.alerts; let i = index">
    <div *ngIf="editModeSet" class="alert__buttons">
      <mat-icon (click)="openEditAlertDialog(i)" class="edit-icon" mat-tooltip="Edit" aria-label="Edit alert">edit</mat-icon>
      <mat-icon (click)="deleteAlert(i)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete alert">delete_outline</mat-icon>
    </div>
    <div [ngClass]="{'alert': true, 'alert--notice': lowPriority(alert.priority) }">
      <div class="alert__text">
        <strong *ngIf="formatTitle(alert)">{{ formatTitle(alert) }}</strong><br/>
        <span class="alert--description" *ngIf="alert.description"><p style="white-space: pre-line">{{ alert.description}}</p></span>
        <a href="{{ formatUrl(alert.website) }}" target="_new" *ngIf="alert.website">Learn More</a>
      </div>
    </div>
  </div>
  <div class="alert__container_add" *ngIf="editModeSet">
    <div class="alert__buttons_add">
      <button id="addAlert" (click)="openEditAlertDialog(null)" mat-mini-fab>
        <mat-icon aria-label="Add Airport Alert">add</mat-icon>
      </button>
    </div>
    <div class="alert__add">
      <div class="alert__text">
        <strong >Add Airport Alert</strong><br/>
        <span class="alert--description">Airport alerts can be used to highlight upcoming and current
          TFRs, runway closures, events, and other items pertinent to the users of this airport.</span><br/>
      </div>
    </div>
  </div>
</div>
